import { useMemo } from 'react';
import { useCurrentUserContext } from '@/contexts/CurrentUserContext';
import { useCollaborators } from '@/features/permissions/hooks/useCollaborators';
import { AvatarStack } from '@/ui';

export const CollaboratorAvatars = () => {
  const { currentUser } = useCurrentUserContext();
  const { collaborators, isLoading } = useCollaborators();

  // Order: current user first, then everyone else. Memoized to avoid re-sorting on every render.
  const users = useMemo(
    () =>
      [...collaborators].sort((a, b) => {
        if (a.id === currentUser?.id) return -1;
        if (b.id === currentUser?.id) return 1;
        return 0;
      }),
    [collaborators, currentUser?.id]
  );

  if (isLoading || collaborators.length <= 1) return null;

  return <AvatarStack max={5} users={users} />;
};
